// extracted by mini-css-extract-plugin
export var attribution = "_8x-4";
export var authorName = "_8x-5";
export var quote = "_8x-3";
export var testimonial = "_8x-2";
export var trustedBy = "_8x-0";
export var trustedByLabel = "_8x-1";